import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad2Actividad4.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[4];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[5].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[5].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[3].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[3].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
        <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Completa el siguiente crucigrama con estas palabras prestadas del
              quechua que usamos cotidianamente.
            </li>
          </ul>
          <div className="row">
            <div className="col-lg-6">
              <div className="border-2 crucigrama shadow-sm border rounded p-2 mt-5 ms-md-5">
                <ol className="pt-3">
                  <li>Abono hecho de excremento de aves.</li>
                  <li>Mamífero de los Andes del que se obtiene lana. </li>
                  <li>Terreno para el cultivo.</li>
                  <li>Mazorca de maíz.</li>
                  <li>
                    Hoja que se mastica en zonas de altura para tener energía.
                  </li>
                  <li>Desnudo, sin ropa.</li>
                </ol>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="my-5  ms-md-5">
                <table className="crucigrama">
                  <tbody>
                    <tr>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <sup>6</sup>
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <sup>1</sup>
                          <input type="text" className="form-control" />
                        </div>
                      </td>{" "}
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>{" "}
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="d-flex justify-content-center">
                          <sup>3</sup>
                          <input type="text" className="form-control" />
                        </div>
                      </td>{" "}
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>{" "}
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="d-flex justify-content-center">
                          <sup>4</sup>
                          <input type="text" className="form-control" />
                        </div>
                      </td>{" "}
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <sup>2</sup>

                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td className="bg-blue"></td>
                    </tr>
                    <tr>
                      <td className="bg-blue"></td>

                      <td>
                        <div className="d-flex justify-content-center">
                          <sup>5</sup>
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td className="bg-blue"></td>
                    </tr>
                    <tr>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td className="bg-blue"></td>
                    </tr>
                    <tr>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td className="bg-blue"></td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <input type="text" className="form-control" />
                        </div>
                      </td>
                      <td className="bg-blue"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que observen la imagen. En ella se presenta
            un crucigrama. Explique que los crucigramas están compuestos por
            casillas cuadradas que están en blanco. Esas casillas se llenan con
            palabras que pueden ser leídas de manera horizontal (de izquierda a
            derecha) o vertical (de arriba a abajo).
          </li>
          <li>
            Lea la indicación: Completa el siguiente crucigrama con estas
            palabras prestadas del quechua que usamos cotidianamente. Pida a un
            niño o niña que lea las seis definiciones que se ofrecen.
          </li>
          <li>
            Explique a sus alumnos que tienen que averiguar a qué se refiere
            cada una de las definiciones dadas. Ponga un ejemplo:{" "}
            <i>
              “Por ejemplo, la primera definición dice “Abono hecho de
              excremento de aves”. ¿A qué palabra se puede referir? Muy bien, se
              trata del guano. Entonces, en el número 1, que es una palabra
              escrita verticalmente, pondremos en cada casilla una letra de la
              palabra guano”.
            </i>
          </li>
          <li>
            Dé un tiempo para que trabajen y luego retome sus
            respuestas preguntando por cada una de las palabras escritas. 1
            guano / 2 llama / 3 chacra / 4 choclo / 5 coca / 6 calato.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
